import { combineReducers, configureStore } from '@reduxjs/toolkit';
import sessionReducer from './slicers/sessionSlice.js';
import activityReducer from './slicers/activitySlice.js';
import userReducer from "./slicers/userSlice.js";
import adminReducer from "./slicers/adminSlice"
import eventReducer from "./slicers/eventSlice.js";

const rootReducer = combineReducers({
	activity: activityReducer,
	session: sessionReducer,
	user: userReducer,
	admin: adminReducer,
	event: eventReducer,
});

const store = configureStore({ reducer: rootReducer });
export default store;
